export default {"src":"/_next/static/media/OpenerIcon.d1babc86.svg","height":72,"width":106};